module.exports = __webpack_public_path__ + "img/SYRIATEL.4652aba0.jpg";